module.exports = __webpack_public_path__ + "static/img/software2.3ad94cde.png";